import React from 'react';

import { toHHMMSS } from 'utils/datetimeParser';
import { useDispatch, useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { Menu } from 'components/Menu';
import { SecondaryMenuItem } from 'components/Menu/SecondaryMenuItem';
import { getSecondaryOpenVideo } from 'store/secondaryViewSlice';
import { RootState } from 'store';

import { getLastVideoByChannel, setSelectedShot, changeVideoShot } from 'store/secondaryChannelVideoSlice';
import { isMobile } from 'react-device-detect';

interface IVideoShots {
  videoShotsData: any;
  channelId: string;
}

function VideoShotDropdown({ videoShotsData, channelId }: IVideoShots) {
  const dispatch = useDispatch();
  const playerIsActive = sessionStorage.getItem('playerActive');
  const secondaryViewVideos = useSelector((state: RootState) => state.secondaryChannelVideos);
  const video = getLastVideoByChannel(secondaryViewVideos, channelId);

  return (
    <div className="min-h-[50px] flex items-center flex-wrap w-full">
      <div className="bg-white rounded-lg w-full">
        <Menu
          menus={videoShotsData.map((menuVideoShot: any, idx: number) => ({
            id: menuVideoShot.shot_hash_id,
            name: `<div class="flex justify-between"><span class="line-clamp-1 mr-2">${
              menuVideoShot.name
            }</span><span class="shrink-0">${toHHMMSS(menuVideoShot.duration)}</span></div>`,
            selected: videoShotsData?.shot_hash_id === menuVideoShot.shot_hash_id,
            onClick: () => {
              dispatch(
                setSelectedShot({
                  channelHashId: channelId,
                  videoHashId: video?.videoHashId as string,
                  newSelectedShot: idx
                })
              );
              if (playerIsActive === 'true') {
                sessionStorage.setItem('hasChangedShots', 'true');
                dispatch(
                  changeVideoShot({
                    channelHashId: channelId,
                    videoShots: videoShotsData,
                    selectedShot: idx
                  })
                );
              }
            }
          }))}
          align="center"
          position="absolute"
          top="mt-8"
          width="100%"
          MenuItem={SecondaryMenuItem}
          additionalClasses="flex justify-center w-full"
          fixedHeight={true}
        >
          <div className="pr-2 h-8 leading-8 rounded-lg text-[13px] font-lato font-bold cursor-pointer w-full flex relative items-center mx-auto z-10 bg-black bg-opacity-5 hover:bg-opacity-10">
            <span className={`truncate w-[calc(100%-24px)] pl-4 ${isMobile ? 'text-[11px]' : ''}`}>
              {videoShotsData?.[video?.selectedShot || 0]?.name}
            </span>
            <KeyboardArrowDownIcon sx={{ width: 20, height: 20 }} />
          </div>
        </Menu>
      </div>
    </div>
  );
}

export default VideoShotDropdown;
